<template>
  <div class="Auth d-flex justify-center align-center fixed-fullscreen" @dblclick.self="close">
    <div class="wrapper d-flex justify-center align-center flex-direction-column" :class="[result]">
      <h2 style="user-select: none;">Auth with OTP</h2>
      <div class="v-textfield">
        <input
          id="otp"
          v-model=code
          type="password"
          title="title"
          :disabled="name"
          required
          autocomplete="off"
          @keyup="input"
          @blur="auth"
        >
        <label for="otp" title="input your OTP Code" data-title="OTP Code"></label>
      </div>
      <div class="result d-flex justify-center align-center">
        <div class="success" v-show="result === 'success'"></div>
        <div class="fail" v-show="result === 'fail'"></div>
      </div>
      <div class="name" :style="{opacity: name ? 1 : 0}"><strong>{{ name }}</strong> 인증됨</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Auth',
  props: ['user'],
  data: () => ({
    code: null,
    result: ''
  }),
  computed: {
    name () {
      return this.user && this.user.name
    }
  },
  methods: {
    input (e) {
      if (e.key === 'Enter') {
        this.auth()
      } else {
        this.result = ''
      }
    },
    auth () {
      this.$socket.client.emit('auth', {code: this.code})
    },
    close () {
      this.$emit('close')
    }
  },
  sockets: {
    auth (data) {
      if (data) {
        this.result = 'success'
        setTimeout(() => {
          this.close()
        }, 500)
      } else {
        this.result = 'fail'
      }
    }
  }
}
</script>

<style scoped>
.Auth {
  background: #000b;
  z-index: 30;
}
.wrapper {
  width: 90vw;
  max-width: 480px;
  height: 90vh;
  max-height: 640px;
  background: white;
}
.result {
  position: relative;
  height: 100px;
  width: 100px;
}
.result>.success::before,
.result>.success::after,
.result>.fail::before,
.result>.fail::after {
  content: '';
  display: inline-block;
  height: 10px;
}
.result>.success::before,
.result>.success::after {
  background: green;
}
.result>.fail::before,
.result>.fail::after {
  background: red;
}
.result>.success::after,
.result>.fail::before,
.result>.fail::after {
  width: 80px;
}
.result>.success::before {
  width: 50px;
  transform: translate(1px, 24px) rotate(45deg);
}
.result>.success::after {
  transform: translate(26px, -6px) rotate(-45deg);
}
.result>.fail::before {
  transform: translate(10px, 9px) rotate(45deg);
}
.result>.fail::after {
  transform: translate(10px, -9px) rotate(-45deg);
}
.wrapper.success,
.wrapper.success .v-textfield input + label::before {
  background: #efe;
}
</style>



// WEBPACK FOOTER //
// src/components/Auth.vue